import React, { Component } from "react";
import PropTypes from "prop-types";
import isEmpty from "src/lib/isEmpty";
import { ErrorList } from "src/react/forms/styles";

export class ValidationErrors extends Component {
  static propTypes = {
    touched: PropTypes.object,
    errors: PropTypes.object,
  };

  static defaultProps = {
    touched: {},
    errors: {},
  };

  render() {
    const { touched, errors } = this.props;

    if (isEmpty(errors)) return null;

    return (
      <ErrorList data-selector="ValidationErrors">
        {Object.keys(errors).map((key) => {
          if (touched[key] == null) return null;
          const message = isEmpty(errors[key])
            ? "Field is invalid"
            : errors[key];
          return <li key={key}>{message}</li>;
        })}
      </ErrorList>
    );
  }
}
